import React from 'react';
import styled from 'styled-components';
import { RichH2, RichP1 } from '../Typography';
import media from '../../utils/media';
import { isFieldValid } from '../../utils/validation';
import { getParsedField } from '../../utils/helpers';
const Container = styled.section ``;
const Header = styled.header `
  outline: none;
  box-sizing: border-box;
  width: 100%;
  padding: 80px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;

  h2:last-child {
    margin-bottom: 0 !important;
  }

  ${media.mobile} {
    padding: 40px 20px;
  }
`;
const ComponentTitle = styled(RichH2) `
  margin-bottom: 20px;
  max-width: 920px;

  ${media.mobile} {
    margin-bottom: 10px;
  }
`;
const ComponentSubtitle = styled(RichP1) `
  max-width: 920px;
`;
// TODO: Delete and use the contained component header instead
export const ComponentHeader = ({ title, subtitle, children, ariaLabel, }) => {
    if (!isFieldValid(title))
        return children;
    const parsedTitle = getParsedField(title);
    const parsedSubtitle = getParsedField(subtitle);
    return (React.createElement(Container, { "aria-label": ariaLabel && ariaLabel.value },
        React.createElement(Header, null,
            React.createElement(ComponentTitle, { field: parsedTitle }),
            isFieldValid(subtitle) && React.createElement(ComponentSubtitle, { field: parsedSubtitle })),
        children));
};
